import React from 'react';
// @ts-ignore
import {Link as RouterLink} from "react-router-dom";
import IndexEconomicResearchComponent from "../../components/indexEconomicResearch/IndexEconomicResearchComponent";
import TextWithImageComponent from "../../components/textWithImage/TextWithImageComponent";
import Images from "../../assets/images/Images";
import FooterHomeComponent from "../../components/footerEconomicResearch/FooterHomeComponent";
import {useTranslation, Trans} from "react-i18next";
import menuIcon from "../../assets/images/ic_menu.png";
import Constants from "../../data/Constants";
import './EconomicResearchContainerStyle.css'
import styled from "styled-components";
import Colors from "../../assets/colors/Colors";
import expand from "../../assets/images/ic_expand.png";
import {RowDiv} from "../../components/styledComponents/CustomStyledComponents";

// @ts-ignore
import {animateScroll as scroll} from "react-scroll";

const Caret = styled.div`
    margin-left: 5px;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 12px solid ${Colors.headerNavigationRed};
    height: 0px;
`;

const StickySideComponent: React.FC = () => {
    return (
        <div style={{position: 'sticky', top: '80%', marginLeft: 50, display: 'inline-flex', flexDirection: 'row', alignItems: 'flex-end', zIndex: 100}}>
            <RouterLink to={Constants.routes.rankings}  style={{cursor: 'pointer', zIndex: 2}}>
                <RoundDivCustom size={80} color={Colors.headerNavigationRed2}>
                    <img src={ Images.icons.graphs } alt="Logo2" style={{ height: 80, width: 80, cursor: 'pointer'}}/>
                </RoundDivCustom>
            </RouterLink>
            <RouterLink to={Constants.routes.gipDownload} style={{cursor: 'pointer', marginLeft: -8, zIndex: 1}}>
                <RoundDivCustom size={40} color={Colors.fontGray}>
                    <img src={ Images.icons.downloadPdfGrey } alt="Logo2" style={{ height: 46, width: 46, cursor: 'pointer' }}/>
                </RoundDivCustom>
            </RouterLink>
        </div>
    )
};

interface RoundDivProps {
    color: string,
    size: number
}
const RoundDivCustom = styled.div`
    background-color: ${(props: RoundDivProps) => (props.color)};
    border-radius:  ${(props: RoundDivProps) => (props.size)}px;
    height: ${(props: RoundDivProps) => (props.size)}px;
    width: ${(props: RoundDivProps) => (props.size)}px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 2px 3px 6px #00000029;
    cursor: pointer;
`;

const RoundDiv = styled.div`
    background-color: white;
    border-radius: 40px;
    height: 40px;
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 6px 18px 13px #00000029;
    cursor: pointer;
`;

const StickyScrollDown: React.FC = () => {

    return(
        <div style={{position: 'sticky', top: '90%', flex: 2, display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1}}>
            <RoundDiv onClick={() => scroll.scrollToBottom()} >
                <img src={expand} alt="Logo2" style={{height: 10, width: 10, cursor: 'pointer'}}/>
            </RoundDiv>
        </div>
    )
};

const TitleComponent: React.FC = () => {
    const { t } = useTranslation();
    return (
        <div style={{marginLeft: 100, marginBottom: -15}}>
            <div style={{fontSize: 47, color: '#E4002B'}}>
                {t('economicResearch.title.title')}
            </div>
            <div style={{fontSize: 27, fontFamily: 'Mapfre-Light'}}>
                {t('economicResearch.title.subTitle')}
            </div>
        </div>
    )
};

const EconomicResearchComponent: React.FC = () => {
    const { t } = useTranslation();
    const backgroundImage = {
        backgroundImage: `url(${Images.mapBackgroundOpacity})`,
        backgroundPosition: 'right center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        backgroundSize: '100%',
        backdropFilter: 'blur(10px)'
    };

    const scrollLinks = [
        {label: '01', to: 'section1'},
        {label: '02', to: 'section2'},
        {label: '03', to: 'section3'},
        {label: '04', to: 'section4'},
        {label: '05', to: 'section5'},
        {label: '06', to: 'section6'},
        {label: '07', to: 'section7'},
    ];

    return (
        <div style={backgroundImage} id='EconomicResearchComponent'>
            <StickySideComponent />
            <TitleComponent/>
            <IndexEconomicResearchComponent scrollLinks={scrollLinks}/>
            <StickyScrollDown />
            <TextWithImageComponent
                title={t('economicResearch.section1.title')}
                text={t('economicResearch.section1.description')}
                displayNumber={'01'}
                whiteBackground={true}
                id="section1"
                image={Images.homeImage5}
                inverted={true}
                imageStyle={{height: 400, marginTop: 70}}
                titlePivot={3}
            >
              <Trans i18nKey='economicResearch.section1.description'>
                Description <a href='https://www.fundacionmapfre.org/documentacion/publico/i18n/catalogo_imagenes/grupo.do?path=1097445' target='_blank'>técnica</a>
              </Trans>
            </TextWithImageComponent>
            <TextWithImageComponent
                title={t('economicResearch.section2.title')}
                text={t('economicResearch.section2.description')}
                displayNumber={'02'}
                whiteBackground={false}
                id="section2"
                image={Images.homeImage3}
                imageStyle={{ transform: 'scaleX(-1)'}}
                titlePivot={2}
            >
              { t('economicResearch.section2.description') }
            </TextWithImageComponent>
            <TextWithImageComponent
                title={t('economicResearch.section3.title')}
                text={t('economicResearch.section3.description')}
                displayNumber={'03'}
                whiteBackground={true}
                image={Images.homeImage4}
                id="section3"
                inverted={true}
                titlePivot={2}
            >
              <Trans i18nKey='economicResearch.section3.description'>
                Description <RouterLink to='/bps'>BPS</RouterLink>
              </Trans>
            </TextWithImageComponent>
            <TextWithImageComponent
                title={t('economicResearch.section4.title')}
                text={t('economicResearch.section4.description')}
                displayNumber={'04'}
                whiteBackground={false}
                id="section4"
                image={Images.homeImage6}
                inverted={false}
                imageStyle={{height: 400}}
                titlePivot={2}
            >
              { t('economicResearch.section4.description') }
            </TextWithImageComponent>
            <TextWithImageComponent
                title={t('economicResearch.section5.title')}
                text={t('economicResearch.section5.description')}
                displayNumber={'05'}
                whiteBackground={true}
                image={Images.homeImage7}
                id="section5"
                inverted={true}
                imageStyle={{height: 400}}
                titlePivot={2}
            >
              { t('economicResearch.section5.description') }
            </TextWithImageComponent>
            <TextWithImageComponent
                title={t('economicResearch.section6.title')}
                text={t('economicResearch.section6.description')}
                displayNumber={'06'}
                whiteBackground={false}
                id="section6"
                inverted={false}
                image={Images.homeImage8}
                imageStyle={{height: 400}}
                titlePivot={3}
            >
              { t('economicResearch.section6.description') }
            </TextWithImageComponent>
            <TextWithImageComponent
                title={t('economicResearch.section7.title')}
                text={t('economicResearch.section7.description')}
                displayNumber={'07'}
                whiteBackground={true}
                image={Images.homeImage9}
                inverted={true}
                id="section7"
                imageStyle={{height: 400}}
                titlePivot={2}
            >
              { t('economicResearch.section7.description') }
            </TextWithImageComponent>
            <TextWithImageComponent
                title={t('economicResearch.section8.title')}
                text={t('economicResearch.section8.description')}
                displayNumber={'08'}
                whiteBackground={false}
                image={Images.homeImage3}
                inverted={false}
                id="section8"
                imageStyle={{height: 600}}
                titlePivot={3}
            >
              { t('economicResearch.section8.description') }
            </TextWithImageComponent>
            <TextWithImageComponent
                title={t('economicResearch.section9.title')}
                text={t('economicResearch.section9.description')}
                displayNumber={'09'}
                whiteBackground={true}
                image={Images.homeImage4}
                inverted={true}
                id="section9"
                imageStyle={{height: 600}}
                titlePivot={3}
            >
              { t('economicResearch.section9.description') }
            </TextWithImageComponent>
            <FooterHomeComponent />
      </div>
    );
};

export default React.memo(EconomicResearchComponent);
